import type { IconComponentProps } from "..";

export function SteamFrameIcon(props: IconComponentProps) {
	return (
		<svg
			{...props}
			fill="currentColor"
			role="img"
			viewBox="0 36.22 388.32 388.32"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Steam Frame</title>
			<path d="m388.32 170.84c-140.11 0-253.68 113.58-253.68 253.69h253.68v-253.69z" fill="var(--brand-2, currentColor)" />
			<path d="m0 44.592c0-4.6264 3.7504-8.3769 8.3769-8.3769h379.94v83.769h-304.54v304.55h-83.768v-379.94z" />
		</svg>
	);
}
